import { MessageHighlight } from '@/infrastructure/domain/chat';

const MessageHighlighter: React.FC<{ message: MessageHighlight }> = ({
  message,
}) => {
  const { text, highlights } = message;

  // Function to split text and insert highlights
  const getHighlightedText = () => {
    if (highlights.length === 0) return text;

    let parts: (string | JSX.Element)[] = [text];

    highlights.forEach(({ highlight, styles }) => {
      parts = parts.flatMap(part =>
        typeof part === 'string'
          ? part.split(new RegExp(`(${highlight})`, 'gi')).map((subPart, i) =>
              subPart.toLowerCase() === highlight.toLowerCase() ? (
                <span key={i} className={styles.join(' ')}>
                  {subPart}
                </span>
              ) : (
                subPart
              ),
            )
          : part,
      );
    });

    return parts;
  };

  return <p>{getHighlightedText()}</p>;
};

export default MessageHighlighter;
